export default __webpack_public_path__ + "static/media/21.3902d65c.jpeg";